import { balloon1x, balloon2x, balloon3x } from 'images/landingpages/health_insurance';
import { Amount, Button } from 'Common';
import { AccessibilityLink } from 'Component';
import { TEXT } from 'locales/landingpages/insuranceCompany';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getZppCertifiedSubscriptionPlan } from 'redux/query';
import { linkHandler } from 'utils/linkHandler';

export const HealthInsuranceCooperationBox = ({ insuranceCompany, insuranceOffer }) => {
  const history = useHistory();
  const plan = useSelector(getZppCertifiedSubscriptionPlan({ course: 'sda' })) ?? {};
  const { asteriskText } = TEXT.refundBox;

  const forwardToPage = () => {
    const url = linkHandler.get('healthInsuranceCooperationCourse', { cooperation: insuranceCompany.slug, course: insuranceOffer.slug });
    history.push(url + '#anmeldung-krankenkasse');
  };

  return (
    <div id="section-checkout-box" className="plans-box-kk-koops-partner px-3 py-5 pt-0 d-flex flex-column mx-auto mt-5 mt-md-0">
      <img
        className="img_balloon_checkout_dak d-block"
        srcSet={`${balloon1x} 165w, ${balloon2x} 330w, ${balloon3x} 495w`}
        src={balloon1x}
        alt="Balloon umsonst"
      />
      <p className="plans-btn-kk__title mt-md-3">{insuranceOffer.title}</p>
      <p className="plans-btn-kk__interval">{insuranceOffer?.checkoutContent?.accessDurationText || ''}</p>
      <p className="plans-box-kk__amount mb-2 align-self-center">
        <Amount value={0} currency={plan.currency} />
      </p>

      <p className="plans-btn-kk__interval mb-2 align-self-center plans-btn-kk__strike_price">
        <Amount value={plan.chargeAmount} currency={plan.currency} />
      </p>
      <div className="text-center">
        <Button className="btn-w-auto mt-auto" onClick={forwardToPage}>
          Jetzt kostenlos starten
        </Button>
      </div>

      <div className="plans-box-kk__info-text mt-4 px-3 px-md-0">
        {asteriskText}
        <br />
        Zu den <AccessibilityLink />
      </div>
    </div>
  );
};
